module.exports = __webpack_public_path__ + "img/alvaro_vaz2.87ed1c7a.jpeg";